module.exports = __webpack_public_path__ + "static/media/notFound.d7988740.svg";